import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { ApiResponse } from "@shared/types";
import { ModalRef } from "@shared/components";
import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { PromocodeBatch } from "@modules/promocodeBatches/types";
import { Agreement } from "@modules/agreements/types";

export function usePromocodeBatchList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createPromocodeBatchModalRef = useRef<ModalRef>(null);
  const editPromocodeBatchModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<PromocodeBatch>({
    resource: "v1/promocode_batch_admin",
    filters: getQueryParams(),
  });

   const agreementIds = useMemo(
      () => [...new Set(rows?.map((company) => company.agreement).filter((id): id is number => !!id))],
      [rows]
    );

    const { data: agreements } = useFetchResourcesByIdsQuery<ApiResponse<Agreement>>({
      resource: "v1/agreement_admin",
      ids: agreementIds,
    });


  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    agreements: agreements?.results,
    selectedRows,
    dataToExport,
    createPromocodeBatchModalRef,
    editPromocodeBatchModalRef,
    refetch,
    setSelectedRows,
    translate,

  };
}
